import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  // Fail loudly in development rather than silently returning nulls later.
  console.error(
    'Supabase keys missing. Copy .env.local.example to .env.local and fill it in, ' +
    'then restart the dev server (env vars are only read at startup).'
  );
}

export const supabase = createClient(url || '', key || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // needed for magic-link callbacks
  },
});

export const isConfigured = Boolean(url && key);
